import {
  ApplicationConfig,
  ErrorHandler,
  APP_INITIALIZER,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
// import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import {
  HttpClient,
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BaseUrlInterceptor } from './shared/interceptors/base-url.interceptor';
import { TimeoutInterceptor } from './shared/interceptors/timeout.interceptor';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { CUSTOM_DATE_FORMATS } from './shared/constants/date.constants';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MultiTranslateHttpLoader } from './shared/loader/multi-translate-loader';
import { LANGS } from './shared/constants/lang.constants';
import { AuthErrorInterceptor } from './shared/interceptors/auth-error.interceptor';
import { LogErrorHandler } from './shared/handlers/log-error.handler';
import { lastValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';

// i18n 檔案名稱列表
const TRANSLATION_FILES = [
  'common',
  'error',
  'header',
  'otp-dialog',
  'home',
  'id-login',
  'login-register',
  'register-verify-contact',
  'set-password',
  'forgot-password-dialog',
  'reserve',
  'reserve-info',
  'reserve-health',
  'reserve-loading',
  'reserve-result',
  'reserve-add',
  'reserve-confirm',
  'reserve-confirm-survey',
  'reserve-confirm-reminder',
  'appointment-info',
  'appointment-time',
  'appointment-confirm',
  'modify-exam-report-dialog',
  'modify-exam-clothes-dialog',
  'modify-exam-diet-dialog',
  'appointment-complete',
  'business-login',
  'business-reserve-result',
  'business-reserve-compare',
  'business-reserve-compare-choose-dialog',
  'business-reserve-choose-group-dialog',
  'member',
  'my-reservation',
  'health-questionnaire',
  'report-query',
  'modify-info',
  'modify-name-dialog',
  'save-phone-dialog',
  'modify-email-dialog',
  'modify-password-dialog',
  'chatbot',
  'not-found',
  'not-available',
  'consent-form',
  'line-message',
  'home-router-dialog',
  'new-home-page',
  'new-member-center',
];

export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, 'assets/i18n/', TRANSLATION_FILES);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    // provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },

    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: LANGS.ZH_TW,
    }),
    // 日期格式
    provideMomentDateAdapter(CUSTOM_DATE_FORMATS),
    { provide: MAT_DATE_LOCALE, useValue: LANGS.ZH_TW },

    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-center',
    }),
    provideAnimations(),
    { provide: ErrorHandler, useClass: LogErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslations,
      deps: [TranslateService],
      multi: true,
    },
  ],
};


// i18n 初始化
export function initializeTranslations(translate: TranslateService) {
  return async () => {
    console.log('APP_INITIALIZER: 開始載入翻譯檔');
    translate.setDefaultLang(LANGS.ZH_TW);

    try {
      // 使用 lastValueFrom 確保抓到翻譯並轉成 Promise
      // take(1) 確保只取一次值就結束
      await lastValueFrom(translate.use(LANGS.ZH_TW).pipe(take(1)));
      console.log('APP_INITIALIZER: 翻譯載入完成');
    } catch (err) {
      console.error('APP_INITIALIZER: 翻譯載入失敗', err);
    }
    return;
  };
}
